import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import TimeUtils from '@shared/utils/time.utils';

@Injectable({ providedIn: 'root' })
export class TimeAgoService {
  constructor(private translate: TranslateService) {}

  timeAgo(input?: Date | string | number): string {
    if (!input) {
      return this.translate.instant('TimeAgo.Unknown');
    }

    const date = TimeUtils.parseUTC(input);

    if (isNaN(date.getTime())) {
      return this.translate.instant('TimeAgo.Unknown');
    }
    const now = Date.now();
    const diffMs = now - date.getTime();

    if (diffMs < 0) {
      return this.translate.instant('TimeAgo.Future');
    }

    const minutes = diffMs / (1000 * 60);
    if (minutes < 60) {
      const m = Math.floor(minutes);

      if (m <= 2) {
        return (this.translate.instant('TimeAgo.JustNow') as string).toLowerCase();
      }

      return this.translate.instant(m === 1 ? 'TimeAgo.Minutes' : 'TimeAgo.MinutesPlural', {
        count: m,
      });
    }

    const hours = diffMs / (1000 * 60 * 60);
    if (hours < 24) {
      const h = Math.floor(hours);
      return this.translate.instant(h === 1 ? 'TimeAgo.Hours' : 'TimeAgo.HoursPlural', {
        count: h,
      });
    }

    const days = hours / 24;
    if (days < 30) {
      const d = Math.floor(days);
      return this.translate.instant(d === 1 ? 'TimeAgo.Days' : 'TimeAgo.DaysPlural', {
        count: d,
      });
    }

    const months = days / 30;
    if (months < 12) {
      const m = Math.floor(months);
      return this.translate.instant(m === 1 ? 'TimeAgo.Months' : 'TimeAgo.MonthsPlural', {
        count: m,
      });
    }

    const years = Math.floor(months / 12);
    return this.translate.instant(years === 1 ? 'TimeAgo.Years' : 'TimeAgo.YearsPlural', {
      count: years,
    });
  }
}
